export default "__VITE_ASSET__bfd59a75__"